// src/users.js
export const users = [
  { username: 'admin', password: '1234', role: 'admin' },
  { username: 'Fernando', password: '0000', role: 'packaging' },
  { username: 'Estefania', password: '0000', role: 'marketing' },
  { username: 'Marta', password: '0000', role: 'marketing' },
  { username: 'Samu', password: '0000', role: 'marketing' },
];
